enum LineItemFormField {
  Product = 'product',
  HasCustomDomainLists = 'hasCustomDomainLists',
  CustomAllowDomains = 'customAllowDomains',
  CustomBlockDomains = 'customBlockDomains',
}

export default LineItemFormField;
